export default {
  'pages.layouts.userLayout.title': '新聞聯播學習',
  'pages.login.accountLogin.tab': '賬戶密碼登錄',
  'pages.login.accountLogin.errorMessage': '錯誤的用戶名和密碼',
  'pages.login.failure': '登錄失敗，請重試！',
  'pages.login.success': '登錄成功！',
  'pages.login.username.placeholder': '用戶名',
  'pages.login.username.required': '用戶名是必填項！',
  'pages.login.password.placeholder': '密碼',
  'pages.login.password.required': '密碼是必填項！',
  'pages.login.phoneLogin.tab': '手機號登錄',
  'pages.login.phoneLogin.errorMessage': '驗證碼錯誤',
  'pages.login.phoneNumber.placeholder': '請輸入手機號！',
  'pages.login.phoneNumber.required': '手機號是必填項！',
  'pages.login.phoneNumber.invalid': '不合法的手機號！',
  'pages.login.captcha.placeholder': '請輸入驗證碼！',
  'pages.login.captcha.required': '驗證碼是必填項！',
  'pages.login.phoneLogin.getVerificationCode': '獲取驗證碼',
  'pages.getCaptchaSecondText': '秒後重新獲取',
  'pages.workbench.link': '歡迎使用',
  'pages.workbench.alertMessage': '更快更強的重型組件，已經發布。',
  'pages.404.subTitle': '抱歉，您訪問的頁面不存在。',
  'pages.404.buttonText': '返回首頁',
  'pages.admin.subPage.title': '這個頁面只有 admin 權限才能查看',
  'pages.admin.subPage.alertMessage':
    'umi ui 現已發佈，歡迎使用 npm run ui 啓動體驗。',
  'pages.searchTable.createForm.newRule': '新建規則',
  'pages.searchTable.updateForm.ruleConfig': '規則配置',
  'pages.searchTable.updateForm.basicConfig': '基本信息',
  'pages.searchTable.updateForm.ruleName.nameLabel': '規則名稱',
  'pages.searchTable.updateForm.ruleName.nameRules': '請輸入規則名稱！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': '規則描述',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': '請輸入至少五個字符',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    '請輸入至少五個字符的規則描述！',
  'pages.searchTable.updateForm.ruleProps.title': '配置規則屬性',
  'pages.searchTable.updateForm.object': '監控對象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': '規則模板',
  'pages.searchTable.updateForm.ruleProps.typeLabel': '規則類型',
  'pages.searchTable.updateForm.schedulingPeriod.title': '設定調度週期',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '開始時間',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': '請選擇開始時間！',
  'pages.searchTable.titleDesc': '描述',
  'pages.searchTable.ruleName': '規則名稱爲必填項',
  'pages.searchTable.titleCallNo': '服務調用次數',
  'pages.searchTable.titleStatus': '狀態',
  'pages.searchTable.nameStatus.default': '關閉',
  'pages.searchTable.nameStatus.running': '運行中',
  'pages.searchTable.nameStatus.online': '已上線',
  'pages.searchTable.nameStatus.abnormal': '異常',
  'pages.searchTable.titleUpdatedAt': '上次調度時間',
  'pages.searchTable.exception': '請輸入異常原因！',
  'pages.searchTable.titleOption': '操作',
  'pages.searchTable.config': '配置',
  'pages.searchTable.subscribeAlert': '訂閱警報',
  'pages.searchTable.title': '查詢表格',
  'pages.searchTable.new': '新建',
  'pages.searchTable.chosen': '已選擇',
  'pages.searchTable.item': '項',
  'pages.searchTable.totalServiceCalls': '服務調用次數總計',
  'pages.searchTable.tenThousand': '萬',
  'pages.searchTable.batchDeletion': '批量刪除',
  'pages.searchTable.batchApproval': '批量審批',
  'pages.template.title': '模板示例',
  'pages.template.submit.success': '表單提交成功！',
  'pages.template.form.name': '姓名',
  'pages.template.form.email': '電子郵箱',
  'pages.template.form.department': '部門',
  'pages.template.form.joinDate': '入職日期',
  'pages.template.form.remarks': '備註',
  'pages.template.placeholder.name': '請輸入姓名',
  'pages.template.placeholder.email': '請輸入電子郵箱',
  'pages.template.placeholder.department': '請選擇部門',
  'pages.template.placeholder.remarks': '請輸入備註資訊',
  'pages.template.validation.nameRequired': '請輸入姓名',
  'pages.template.validation.emailRequired': '請輸入電子郵箱',
  'pages.template.validation.emailInvalid': '電子郵箱格式不正確',
  'pages.template.validation.departmentRequired': '請選擇部門',
  'pages.template.validation.joinDateRequired': '請選擇入職日期',
  'pages.template.department.tech': '技術部',
  'pages.template.department.sales': '銷售部',
  'pages.template.department.hr': '人力資源部',
  'pages.template.department.finance': '財務部',
  'pages.template.action.submit': '提交',
  'pages.template.action.reset': '重置',
  'pages.newsBroadcast.dashboard.title': '分析概覽',
  'pages.newsBroadcast.dashboard.subtitle': '新聞聯播數據總覽與快捷操作',
  'pages.newsBroadcast.analysis.title': '每日聯播研判',
  'pages.newsBroadcast.analysis.subtitle':
    '看懂當天新聞聯播釋放的政策、產業與社會信號',
  'pages.newsBroadcast.analysisTasks.title': '分析任務中心',
  'pages.newsBroadcast.analysisTasks.subtitle':
    '任務狀態追蹤、失敗重試與快照重建',
  'pages.newsBroadcast.search.title': '新聞搜索',
  'pages.newsBroadcast.search.subtitle': '按關鍵詞與篩選條件檢索新聞',
  'pages.newsBroadcast.keywordTrends.title': '全域詞彙趨勢',
  'pages.newsBroadcast.keywordTrends.subtitle':
    '按時間範圍分析詞彙熱度、活躍度與趨勢變化',
  'pages.newsBroadcast.dailyBrief.title': '每日簡報',
  'pages.newsBroadcast.dailyBrief.subtitle': '按人群生成並分發每日簡報',
  'pages.newsBroadcast.dailyBriefDetail.title': '簡報詳情',
  'pages.newsBroadcast.dailyBriefDetail.subtitle':
    '完整正文、核心要點、隱藏信號與行動建議',
  'pages.newsBroadcast.shareBrief.title': '每日聯播簡報',
  'pages.newsBroadcast.shareBrief.notFound': '簡報不存在或已失效',
  'pages.newsBroadcast.shareBrief.keyPoints': '核心要點',
  'pages.newsBroadcast.shareBrief.hiddenSignals': '隱藏信號',
  'pages.newsBroadcast.shareBrief.actionAdvice': '行動建議',
  'pages.newsBroadcast.shareBrief.readingTime': '預計閱讀 {minutes} 分鐘',
  'pages.newsBroadcast.shareBrief.footer': '內容由 AI 生成，來自「{brand}」',
  'pages.newsBroadcast.dataManagement.title': '數據管理',
  'pages.newsBroadcast.dataManagement.subtitle': '管理聯播期次與新聞明細數據',
  'pages.newsBroadcast.admin.title': '管理後台',
  'pages.newsBroadcast.admin.subtitle': '執行採集、分析、清理等管理操作',
  'pages.newsBroadcast.settings.title': '系統設置',
  'pages.newsBroadcast.settings.subtitle': '配置通知、分析與數據源參數',
  'newsBroadcast.dataManagement.broadcastList': '新聞聯播列表',
  'newsBroadcast.dataManagement.newsDetail': '新聞詳情',
  'newsBroadcast.dataManagement.selectBroadcast': '請選擇一條新聞聯播',
  'newsBroadcast.dataManagement.noNews': '暫無新聞數據',
  'newsBroadcast.dataManagement.newsCount': '新聞數量',
  'newsBroadcast.dataManagement.lunarDate': '農曆',
  'newsBroadcast.dataManagement.solarTerm': '當前節氣',
  'newsBroadcast.dataManagement.nextSolarTerm': '下一節氣',
  'newsBroadcast.dataManagement.summary': '摘要',
  'newsBroadcast.dataManagement.noSummary': '暫無摘要',
  'newsBroadcast.dataManagement.readCount': '閱讀量',
  'newsBroadcast.dataManagement.shareCount': '分享量',
  'newsBroadcast.dataManagement.heatScore': '熱度評分',
  'newsBroadcast.dataManagement.keywordAnalysis': '關鍵詞分析',
  'newsBroadcast.dataManagement.contentAnalysis': '內容分析',
  'newsBroadcast.common.refresh': '刷新',
  'newsBroadcast.common.noData': '暫無數據',
  'newsBroadcast.common.error': '操作失敗，請稍後重試',
  'newsBroadcast.common.published': '已發佈',
  'newsBroadcast.common.draft': '草稿',
  'newsBroadcast.common.archived': '已歸檔',
  'newsBroadcast.common.view': '查看',
  'newsBroadcast.common.share': '分享',
  'newsBroadcast.common.download': '下載',
  'newsBroadcast.common.keyword': '關鍵詞',
};
